/**
 * WizardProgressBar — shows "Step X of 10" with a visual progress bar.
 * Rendered above each step's content area.
 */

import { WIZARD_STEPS } from '../../constants/wizardSteps';

interface WizardProgressBarProps {
  currentStep: number;
}

const TOTAL_STEPS = WIZARD_STEPS.length;

export function WizardProgressBar({ currentStep }: Readonly<WizardProgressBarProps>) {
  const stepLabel = WIZARD_STEPS.find(s => s.number === currentStep)?.label ?? '';
  const progressPct = (currentStep / TOTAL_STEPS) * 100;

  return (
    <div className="wizard-progress-bar">
      <div className="wizard-progress-bar-text">
        <span className="wizard-progress-bar-step">
          Step {currentStep} of {TOTAL_STEPS}
        </span>
        <span className="wizard-progress-bar-label">{stepLabel}</span>
      </div>
      <div className="wizard-progress-bar-track">
        <div
          className="wizard-progress-bar-fill"
          style={{ width: `${progressPct}%` }}
          role="progressbar"
          aria-valuenow={currentStep}
          aria-valuemin={1}
          aria-valuemax={TOTAL_STEPS}
          aria-label={`Step ${currentStep} of ${TOTAL_STEPS}: ${stepLabel}`}
        />
      </div>
    </div>
  );
}
